import { HorizontalSpaceBetween, IconButton, VerticalContainer } from '@american-autonomy/ag-ui';

import CloseIcon from 'components/icons/CloseIcon';
import CaptionText from 'components/text/CaptionText';
import DrawerTitleText from 'components/text/DrawerTitleText';

import { CLOSE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneDetailsDrawerHeader: FunctionComponent<Props> = ({
    className = '',
    name,
    onClose,
    serial,
    testId = TEST_ID
}) => (
    <HorizontalSpaceBetween
        className={`${className} ${styles.droneDetailsDrawerHeader}`}
        testId={testId}>
        <VerticalContainer className={styles.verticalContainer}>
            <DrawerTitleText className={styles.bodyText} text={name} />

            <CaptionText className={styles.captionText} text={serial} />
        </VerticalContainer>

        <IconButton className={styles.iconButton} onClick={onClose} testId={CLOSE_BUTTON_TEST_ID}>
            <CloseIcon className={styles.closeIcon} />
        </IconButton>
    </HorizontalSpaceBetween>
);

export default DroneDetailsDrawerHeader;
